// How the audit trail's "Object" column is rendered — shared by BOTH audit surfaces: the global
// Audit Trail screen (`screens/LimsScreen/AuditViewer`) and the analysis-task audit section
// (`components/Lims/ResultEntryPanel/AuditSection`).
//
// It lives in one module deliberately (SPEC-049 R12). `objectTypeLabel` was previously duplicated
// byte-for-byte in both files, and that duplication is exactly how RR8 #4063 and #4068 came to be
// filed as two separate issues: one root cause, two surfaces, no shared code to fix once.

// A canonical UUID. This is the shape the pre-fix backend wrote into `object_label`, the column
// reserved for the HUMAN label (backend SPEC-052 R11 closed the write path).
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export function objectTypeLabel(typ, t) {
  if (!typ) return ""
  if (typ === "member") return t("member")
  if (typ === "product") return t("limsAuditTypeProduct")
  if (typ === "consumable") return t("limsAuditTypeConsumable")
  if (typ === "reagent") return t("limsAuditTypeReagent")
  if (typ === "oos") return t("limsAuditTypeOos")
  if (typ === "sample") return t("limsAuditTypeSample")
  if (typ === "result") return t("limsAuditTypeResult")
  if (typ === "forskrift") return t("limsAuditTypeForskrift")
  if (typ === "qaDecision") return t("limsAuditTypeQaDecision")
  if (typ === "batch") return t("limsAuditTypeBatch")
  if (typ === "rerun") return t("limsAuditTypeRerun")
  if (typ === "investigation") return t("limsAuditTypeInvestigation")
  if (typ === "capa") return t("limsAuditTypeCapa")
  if (typ === "sst") return t("limsAuditTypeSst")
  if (typ === "commentTemplate") return t("limsAuditTypeCommentTemplate")
  return typ
}

// The Object cell for one audit entry (SPEC-049 R12).
//
// Prefers the stored human label, but NEVER renders a bare UUID: rows written before the backend
// fix carry the analysis id in `object_label`, and the audit table is append-only — those rows are
// deliberately never rewritten, so the fallback is permanent, not transitional. A UUID tells an
// auditor nothing, whereas the object TYPE ("Result", "Sample") at least says what was acted on.
export function auditObjectLabel(entry, t) {
  const label = entry && entry.objectLabel
  if (label && !UUID_RE.test(label)) return label
  return objectTypeLabel(entry && entry.objectType, t)
}
